import { Mail } from 'lucide-react';

export function NoGroupsMessage() {
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="max-w-2xl mx-auto text-center px-4">
        <div className="mb-6">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-100 dark:bg-blue-900/30 mb-4">
            <Mail className="w-8 h-8 text-blue-600 dark:text-blue-400" />
          </div>
        </div>
        <h1 className="text-3xl font-semibold text-gray-900 dark:text-gray-100 mb-4">
          Welcome to MAXIRON Portal
        </h1>
        <p className="text-lg text-gray-600 dark:text-gray-400 mb-6 leading-relaxed">
          You have been successfully authenticated and registered as a portal user. However, you have not yet been assigned to any user groups that grant access to portal features.
        </p>
        <div className="mt-8 rounded-lg border border-blue-200 bg-blue-50 px-4 py-3 text-blue-900 dark:border-blue-900/40 dark:bg-blue-950/30 dark:text-blue-100">
          <p className="text-base font-semibold">
            This page will automatically refresh once an administrator grants you access.
          </p>
        </div>

        <div className="mt-6 flex justify-center">
          <a
            href="mailto:support@maxiron.com"
            className="inline-flex items-center justify-center px-4 py-2 bg-gray-100 hover:bg-gray-200 dark:bg-gray-900 dark:hover:bg-gray-800 text-gray-900 dark:text-gray-100 rounded-lg transition-colors font-medium"
          >
            Contact Support
          </a>
        </div>
      </div>
    </div>
  );
}

